export enum RachelProductCardsTestIds {
  CAROUSEL = 'rachel-product-cards-carousel',
  LIST = 'rachel-product-cards-list',
  CARD = 'rachel-product-card',
  ROW = 'rachel-product-row',
}
